module.exports = __webpack_public_path__ + "static/media/pptxType.4b5f0860.png";